import React from "react";
import { GisMapWrapper } from "@gis/GisMapWrapper";
import MapClickCoordinates from "@gis/components/MapClickedCoordinates";
import GenericMarker from "@gis/components/GenericMarker";
import CurrentLocation from "@gis/assets/images/logo/current_location.svg";
import MarkerLocation from "@gis/assets/images/logo/noc-green-marker.svg";
import { useSelector } from "react-redux";
import LocationMarker from "@gis/components/LocationMarker";
import { nocLocationElement } from "@gis/components/overlayElements";

interface MapPanelProps {
    hideRemovePin: boolean;
    geoCoordinates: any;
    coordinates: {
        longitude: string | number;
        latitude: string | number;
    };
    chainages: string;
    onMapClick: (coords: { latitude: number; longitude: number }) => void;
    isFirstSectionCompleted: boolean;
}


const DEFAULT_CENTER: [number, number] = [77.31344843909721, 28.567578971251322];

function getMapCenter(
    start_coordinates: { longitude: string | number; latitude: string | number },
    geoCoordinates: { longitude: string | number; latitude: string | number }
): [number, number] {
    const startLat = Number(start_coordinates?.latitude) || 0;
    const startLng = Number(start_coordinates?.longitude) || 0;
    const geoLat = Number(geoCoordinates?.latitude) || 0;
    const geoLng = Number(geoCoordinates?.longitude) || 0;

    if (startLat !== 0 && startLng !== 0) return [startLng, startLat];
    if (geoLat !== 0 && geoLng !== 0) return [geoLng, geoLat];
    return DEFAULT_CENTER;
}

const MapPanel = React.memo(({ hideRemovePin, geoCoordinates, coordinates, chainages, onMapClick, isFirstSectionCompleted }: MapPanelProps) => {

    const { searchCoordinates } = useSelector((state: any) => state.gisData);
    const [zoomLevel, setZoomLevel] = React.useState<number>(9);

    React.useEffect(() => {
        if (searchCoordinates.longitude !== 0 || center[0] !== 0) {
            setZoomLevel(15);
        } else {
            setZoomLevel(9);
        }
    }, [coordinates, geoCoordinates]);

    const center = getMapCenter(coordinates, geoCoordinates);

    return (
        <div className="amenities-container" style={{ pointerEvents: !isFirstSectionCompleted ? "none" : "auto", opacity: !isFirstSectionCompleted ? 0.5 : 1 }}>
            <GisMapWrapper center={searchCoordinates.latitude === 0 ? center : [searchCoordinates.longitude, searchCoordinates.latitude]} zoom={zoomLevel}>
                <MapClickCoordinates onClick={onMapClick} />
                {(geoCoordinates?.longitude !== 0 && geoCoordinates?.latitude !== 0) && (
                    <GenericMarker
                        coordinates={[
                            Number(geoCoordinates?.longitude) || 0,
                            Number(geoCoordinates?.latitude) || 0,
                        ]}
                        size={0.5}
                        anchor={[0.5, 1]}
                        img={CurrentLocation}
                    />
                )}
                {(coordinates?.longitude !== 0 && coordinates?.latitude !== 0) && (
                    <GenericMarker
                        coordinates={[
                            Number(coordinates?.longitude) || 0,
                            Number(coordinates?.latitude) || 0,
                        ]}
                        size={0.5}
                        anchor={[0.5, 1]}
                        img={MarkerLocation}
                    />
                )}
                {(coordinates?.longitude !== 0 && coordinates?.latitude !== 0) && (
                    <>
                        <GenericMarker
                            coordinates={[
                                Number(coordinates?.longitude) || 0,
                                Number(coordinates?.latitude) || 0,
                            ]}
                            size={0.5}
                            anchor={[0.5, 1]}
                            img={MarkerLocation}
                        />

                        <LocationMarker
                            coordinates={[
                                Number(coordinates?.longitude) || 0,
                                Number(coordinates?.latitude) || 0,
                            ]}
                            html={
                                nocLocationElement(coordinates?.latitude.toString() || '0',
                                    coordinates?.longitude.toString() || '0',
                                    chainages,
                                    'startLocation')}
                        />

                    </>
                )}
            </GisMapWrapper>
        </div>
    )
});

export default MapPanel;